"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _default = function _default() {
  var scrollBarWidth = 0;

  if (typeof window !== "undefined") {
    // Add temporary box to wrapper
    var scrollbox = document.createElement("div"); // Make box scrollable

    scrollbox.style.overflow = "scroll"; // Append box to document

    document.body.appendChild(scrollbox); // Measure inner width of box

    scrollBarWidth = scrollbox.offsetWidth - scrollbox.clientWidth; // Remove box

    document.body.removeChild(scrollbox);
  }

  return scrollBarWidth;
};

exports["default"] = _default;